import getStaticData from "common/fetch/getStaticData";

import Layout from "components/common/Layout";
import OrderProcess from "components/templates/common/order-process";

import dataJson from "./data.json";

export default function Home({ data }) {
  return (
    <Layout locationRouter="offshore" navLight={true} page={data.page}>
      <OrderProcess data={data} dataJson={dataJson} />
    </Layout>
  );
}

export const getStaticProps = async () => {
  const data = await getStaticData({
    locale: "offshore",
    uri: "/order-process",
  });

  return {
    props: {
      data,
      revalidate: 1,
    },
  };
};
